module.exports = __webpack_public_path__ + "img/masked_fisio.193acd64.svg";